import React, { Component } from "react"
import Helping from "../../helpers/Helping"
import Service from "../../helpers/service"
import Notification from "../layout/Notification"
import MoneyField from '../fields/moneyField'
import route from '../../config/routes'
import { addCurrentRoute } from '../../actions/profile_action'
import { getAll } from "../../services/user.service"
import { connect } from 'react-redux'
import { MESSAGE, TRANSACTION } from '../../config/index'
import LoadingButton from '../fields/LoadingButton'
import { setErrorFields, validateField } from "../../helpers/validationHelpers"
import {
    API_URL,
} from '../../config/urls';
import { trackPromise } from "react-promise-tracker";
import jQuery from "jquery";

const { NOT_FOUND } = MESSAGE
class Detail extends Component {
    constructor(props) {
        super(props)

        this.state = {
            url: '',
            user: {},
            routeName: '/user',
            error_message: '',
            error_type: '',
            isLoading: true,
            btnIsEnable: false,
            search: props.search,
            activePage: props.page,
            limit: props.limit,
            sorting: 'id',
            sort_type: 'DESC',
            charge_id: '',
            amount: '',
            type: '',
        }
        this.closeModal = this.closeModal.bind(this)
    }

    handleValueChange = async (e) => {
        let { name, value } = e.target;

        if (name === "amount") {
            value = value.replace("$", "");
            value = value.replace(/[^0-9\\.]+/g, '');
        }
        else if (name === "type" && value === "debit") {
            this.setState({ charge_id: "" });
        }
        this.setState({ [name]: value });

        if (name === "charge_id") this.setState({ ...await validateField("string", name, value, "") })
        if (name === "amount") this.setState({ ...await validateField("decimal", name, value, "", 100) })
        if (name === "type") this.setState({ ...await validateField("string", name, value, "") })
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }

    componentDidMount() {
        var self = this
        if (this.props.match.params.id) {

            self.setState({
                url: API_URL.ADMIN_API + route.GET_USER
            }, function () {
                self.getById()
                this.props.addCurrentRoute(this.props.profile, this.props.location.pathname)
            })
        }
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() })
    }

    getById = () => {
        let self = this

        trackPromise(
            Service.getCall(this.state.url + this.props.match.params.id)
                .then((response) => {
                    var { user } = response.data.payload

                    self.setState({
                        user: user,
                        isLoading: false,
                    })
                })
                .catch((error) => {
                    if (error.response) {
                        Helping.redirectToLogin(error)
                        return self.setState(
                            {
                                error_message: error.response.data.message,
                                error_type: 'danger',
                                isLoading: false,
                            },
                            () => this.scrollToTop()
                        )
                    }
                    return this.setState(
                        {
                            isLoading: false,
                            ...Helping.setNetworkRequestError(error, 'fetching user'),
                        },
                        () => this.scrollToTop()
                    )
                })
        )
    }

    updateAmount = () => {
        this.setState({ btnIsDisable: true })

        let self = this,
            state = this.state,
            data = {
                action: "update-user-wallet",
                userId: Number(state.user.id),
                amount: state.amount ? Number(parseFloat(state.amount).toFixed(5)) : 0,
                charge_id: state.type === 'debit' ? "" : state.charge_id,
                type: state.type
            }

        Service.postCall(API_URL.ADMIN_TRADING_API + "reports/", data)
            .then(response => {
                let { wallet } = response.data.payload;

                self.setState(
                    {
                        user: { ...this.state.user, wallet: wallet },
                        error_message: "User's Wallet is Updated successfully.",
                        error_type: "success",
                        btnIsDisable: false
                    }, () => {
                        this.closeModal();
                        this.scrollToTop();
                        // this.getById();
                        this.getUsers();
                    }
                )
            })
            .catch(error => {
                if (error.response) {
                    Helping.redirectToLogin(error)
                    return this.setState({
                        error_message: error.response.data.message,
                        error_type: 'danger',
                        btnIsDisable: false
                    }, () => { this.closeModal(); this.scrollToTop() })
                }
                return this.setState({
                    isLoading: false,
                    btnIsDisable: false,
                    ...Helping.setNetworkRequestError(error, "updating user's wallet")
                }, () => { this.closeModal(); this.scrollToTop(); })
            });
    }

    getUsers = () => {
        let search = this.state.search

        this.props.getAll(
            this.state.activePage,
            this.state.limit,
            search ? search.trim() : "",
            this.state.sorting,
            this.state.sort_type,
            "",
            "",
            "",
            ""
        )
    }

    closeModal() {
        this.setState({
            amount: '',
            type: '',
            charge_id: ''
        },
            () => {
                window.$('#confirmationModal').modal('hide')
            }
        )
    }

    onConfirm = () => {
        let formHasError = this.checkEmptyInputFields()
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        window.$('#editAmount').modal('hide')
        window.$('#confirmationModal').modal('show')
    }

    checkEmptyInputFields = () => {
        let { state } = this,
            formHasError = false

        if (parseFloat(state.amount) <= 0) {
            let errorObject = setErrorFields("amount", "Amount should not be empty or less then 0.");
            this.setState(errorObject);
            formHasError = true;
        }

        if (state.type === "") {
            let errorObject = setErrorFields("type", "Type should not be empty.")
            this.setState(errorObject)
            formHasError = true
        }
        return formHasError
    }

    render() {
        const { user } = this.state

        return (
            <div class="content user-view">
                {this.state.error_message &&
                    <Notification
                        type={this.state.error_type}
                        message={this.state.error_message}
                        callback={this.removeNetworkError}
                    />
                }
                {!jQuery.isEmptyObject(user) && (
                    <>
                        <div class="top-header">
                            <div class="header-title">
                                <h2 class="title">{user.firstName} {user.lastName}</h2>
                                <span class="title-caption">Customer</span>
                            </div>
                            <div class="header-btn">
                                <button class="custom-btn dark-btn icon-btn sm-btn" onClick={() => this.props.history.goBack()}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15.5" height="12.117" viewBox="0 0 15.5 12.117">
                                        <g id="Arrow_-_Left" data-name="Arrow - Left" transform="translate(0.75 1.059)">
                                            <g id="Arrow_-_Left-2" data-name="Arrow - Left" transform="translate(14) rotate(90)">
                                                <path id="Stroke_1" data-name="Stroke 1" d="M0,14V0" transform="translate(5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                                <path id="Stroke_3" data-name="Stroke 3" d="M10,0,5,5.647,0,0" transform="translate(0 8.353)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1.5" />
                                            </g>
                                        </g>
                                    </svg>
                                    <span class="txt-btn">Back</span>
                                </button>
                            </div>
                        </div>
                        <div class="main-content  view-page-content">
                            <div class="view-tabs multiple-tabs">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#personal" role="tab">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20">
                                                <path id="user" d="M12,2a4.985,4.985,0,1,0,5,4.984A4.993,4.993,0,0,0,12,2Zm0,1.994a2.991,2.991,0,1,1-3,2.99A3,3,0,0,1,12,3.994Zm2,8.972a5.99,5.99,0,0,1,6,5.981v2.025a1,1,0,0,1-2,0V18.947a3.994,3.994,0,0,0-4-3.987H10a3.994,3.994,0,0,0-4,3.987V21a1,1,0,0,1-2,0V18.947a5.99,5.99,0,0,1,6-5.981Z" transform="translate(-4 -2)" />
                                            </svg>
                                            <span class="tab-text">Personal</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="tab-content">
                                <div class="tab-pane active userPersonalInfo" id="personal" role="tabpanel">
                                    <div class="row align-items-center user-profile">
                                        <div class="col-md-12 col-lg-3 user-info-col">
                                            <div class="user-dp">
                                                <img src={user.default_avatar ? user.default_avatar.thumbnail_url : "/img/default_user_img.png"} alt="" class="img-fluid" />
                                            </div>
                                            <h5 class="user-name">{user.firstName} {user.lastName}</h5>
                                            <span class="user-status">Status: {user.isConfirmed ? "Verified" : "Disproved"}</span>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-4">
                                            <ul class="list-view">
                                                <li>
                                                    <label for="">Username</label>
                                                    <span>{user.username}</span>
                                                </li>
                                                <li>
                                                    <label for="">Firstname</label>
                                                    <span>{user.firstName}</span>
                                                </li>
                                                <li>
                                                    <label for="">Lastname</label>
                                                    <span>{user.lastName}</span>
                                                </li>
                                                <li>
                                                    <label for="">Email</label>
                                                    <span class="user-email">{user.email ? user.email : ""}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-sm-6 col-md-6 col-lg-4">
                                            <ul class="list-view">
                                                <li>
                                                    <label for="">User ID</label>
                                                    <span>{user.id}</span>
                                                </li>
                                                <li>
                                                    <label for="">Date of Birth</label>
                                                    <span>{user.birthDate ? user.birthDate : 'Nil'}</span>
                                                </li>
                                                <li>
                                                    <label for="">Wallet</label>
                                                    <span>{user.wallet ? <MoneyField value={user.wallet} /> : "$" + 0}</span>
                                                </li>
                                                <li>
                                                    <label for="">Country</label>
                                                    <span>{user.country ? user.country.name : ""}</span>
                                                </li>

                                            </ul>
                                            {/* <div style={{ alignItems: 'center', float: 'right' }}>
                                                <button class="custom-btn sm-btn gradiant-btn"
                                                    data-target="#editAmount" title="Edit Wallet" data-toggle="modal" data-placement="bottom">
                                                    Update Wallet
                                                </button>
                                            </div> */}
                                        </div>
                                        <div class="col-lg-12 col-sm-6">
                                            <div style={{ alignItems: 'center', float: 'right' }}>
                                                <button class="custom-btn sm-btn gradiant-btn"
                                                    data-target="#editAmount" title="Edit Wallet" data-toggle="modal" data-placement="bottom">
                                                    Update Wallet
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </>
                )}
                {(jQuery.isEmptyObject(user) && !this.state.isLoading) && (
                    <div className='table-responsive'>
                        <Notification
                            type='danger'
                            message={Helping.getMessageString(
                                NOT_FOUND,
                                'User '
                            )}
                            callback={this.removeNetworkError}
                        />
                    </div>
                )}

                { /* Update Wallet */}
                <div class="actionModal modal fade" id="editAmount" tabindex="-1" role="dialog" aria-labelledby="editAmount" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="">Update User's Wallet</h5>
                            </div>

                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <label for="type">Type </label>
                                            <select class={`form-select ${this.state.error_type_message ? 'error-input' : ''}`} aria-label="Default select example" id="type"
                                                name='type' value={this.state.type} onChange={(e) => this.handleValueChange(e)}>
                                                <option value="" selected>Select Type...</option>
                                                <option value="credit">Credit</option>
                                                <option value="debit">Debit</option>
                                            </select>
                                            <span className="error-msg">{this.state.error_type_message}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <label for="amount">Amount </label>
                                            <input type="text" class={`form-control ${this.state.error_amount_message ? 'error-input' : ''}`} id="amount" name="amount" value={this.state.amount} onChange={(e) => this.handleValueChange(e)} />
                                            <span className="error-msg">{this.state.error_amount_message}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="chargeId">Charge ID </label>
                                    <input type="text" class={`form-control ${this.state.error_charge_id_message ? 'error-input' : ''}`} id="chargeId" disabled={this.state.type === 'debit'} name="charge_id" value={this.state.charge_id} onChange={(e) => this.handleValueChange(e)} />
                                    <span className="error-msg">{this.state.error_charge_id_message}</span>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>
                                <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={this.onConfirm}>Update</button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ----- Confirmation Modal ----- */}
                <div class="actionModal modal fade" id="confirmationModal" tabindex="-1" role="dialog" aria-labelledby="confirmationModal" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Confirm Wallet Updation</h5>
                            </div>

                            <div class="modal-body">
                                <p class="modal-msg">You are about to update the user's wallet.</p>
                                <p><strong>Do you want to proceed?</strong></p>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>

                                {this.state.btnIsDisable ? (
                                    <LoadingButton class_name={"sm-btn"} />
                                ) : (
                                    <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={this.updateAmount}>
                                        <span>
                                            {this.state.btnIsDisable ? "Loading..." : "Submit"}
                                        </span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

const mapStateToProps = state => ({
    profile: state.profile,
    search: state.fetchUsersMeta.search,
    page: state.fetchUsersMeta.page,
    limit: state.fetchUsersMeta.limit
})

const mapDispatchToProps = {
    addCurrentRoute,
    getAll,
}

export default connect(mapStateToProps, mapDispatchToProps)(Detail)